import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import { UserService } from '../../services/user.service';
import { InterpolateService } from '@ispm/shared/services/interpolate.service';
import { Ipractitioner } from '../../interfaces/practitioner.interface';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { UserCounterTableComponent } from './user-counter-table/user-counter-table.component';
import { Subscription } from 'rxjs/Subscription';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';
import { UserMergeNotificationModalComponent } from '../user-merged-notification/user-merge-notification-modal.component';
import { PatientInfoService } from '@ispm/user/services/patientInfo.service';
import {SessionStorageService} from "@ispm/shared/services/session-storage.service";
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import {  get } from 'lodash';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { Injectable } from '@angular/core';
import { map, switchMap, take,distinctUntilChanged,takeUntil } from 'rxjs/operators';
import {combineLatest,  of} from 'rxjs';
import { distinctUntilKeyChanged,} from 'rxjs/operators';
import { PatientService } from '@ispm-client/modules/patient/services/patient.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import {BrowserCacheService} from "@ispm/core/services/browser-cache.service";
import {ArrayUtils} from "@ispm/shared/utils/Array.utils";
import {Subject} from "rxjs";


@Component({
  selector: 'gen-user-counter-warning',
  templateUrl: './user-counter-warning.component.html',
  styleUrls: ['./user-counter-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
@Injectable()
export class UserCounterWarningComponent implements OnInit, OnDestroy {
  public count: number;
  public users: Ipractitioner[] | any[];
  public currentApp: string

  @Input() warningMinimumAmount: number = 2;
  @Input() textTemplate: string = '$(count) Other $(patientText) named &nbsp<b>$(name)</b>&nbsp $(existText) in the system';
  @Input() tooltipText: string;
  @Input() userId: string;
  @Input() backUrl: string = 'Pathologist';
  @Input() backUrlParams: object;
  @Input() showDuplicatePatient: boolean;
  @Input() proceedCallback?: () => void;  //When callback function is passed, it will be called when user clicks on Proceed. If not, the component will navigate to the supplied url
  @Input() backCallback?: () => void;
  @Input() callbackObject: any;
  @Input() orderId: String="";
  @Input() name: String = "";

  private subscriber: Subscription;
  private destroyed: boolean = false;
  private _destroyed$: Subject<any> = new Subject();

  private showMergePatientModal = false;
  private userMergedFrom = false;
  private userMergedToMrn: string;
  private userInactive = false;
  private userName;
  private showMergedPatient;
  public currentPaientMergedIdentifier: any;

  @Input()
  set params(params) {
    let patientId = params['userId']
    let name = params['name']

    let from = ""
    if("from" in params){
      from = params['from']
    }
    this.store.select('navigation', 'currentApp').take(1).subscribe((app) => {
      this.currentApp = app?.id;
    });
    this.store.select('users', 'currentPatientIdentifiers').take(1).subscribe(identifierData => {
      this.currentPaientMergedIdentifier = identifierData;
    })
    if (this.currentApp === 'ISPM-PATHOLOGY-GENOMICS-APP' && from !== "new-order") {
      return
    }
    if (name){
      let doTestType = ""
      this.store.select('tests','diagnosticOrders')
      .take(1)
      .subscribe((data) => {
        doTestType = get(data, 'order.testType');
      });
      this.patientWarning(patientId, name, doTestType, this.currentApp, from)
    }
  }
  constructor(
    private store: Store<IgenomicsState>,
    private user: UserService,
    private _changeDetector: ChangeDetectorRef,
    private _route: Router,
    private _modalLoader: DynamicModalLoaderService,
    private interpolator: InterpolateService,
    private patientInfoService: PatientInfoService,
    private session: SessionStorageService,
    private _ispmHttpClient: IspmHttpClient,
    private _location: Location,
    private patientService: PatientService,
    private _browserCacheService: BrowserCacheService,
  ) {
  }

  ngOnInit() {
    //duplicate and merged patient flows should act the same, but are separated in case of future changes to each case
    this.showMergedPatient = this.showDuplicatePatient;
  }

  private patientWarning(patientId,name, doTestType, appName, from){
    let sameNamePatientWarningList = []
    let filteredPatientsWithSameName = []
    this.extractSelectedPatientDetails(patientId).pipe(ArrayUtils.filterEmpty(),
      distinctUntilKeyChanged("id"),takeUntil(this._destroyed$.asObservable()),
      map((extractedpatientObj) => {
        if( (this.currentApp === "ISPM-ONCOLOGY-PATHWAYS-NAVIGATOR-APP" && from === "test-header")
             || this.session.getDuplicatePatientWarning(patientId) ) {
          if (this.proceedCallback){//If callback is defined, do not navigate
            this.proceedCallback();
          }
          return
        }
        this.getCurrentPatientRow(extractedpatientObj, doTestType, appName).pipe(takeUntil(this._destroyed$.asObservable()),
          map((currentPatientWarningList) => {
            let warning = {}
            this.getPatientsWithSameName(name, extractedpatientObj).pipe(take(1),distinctUntilChanged(),takeUntil(this._destroyed$.asObservable()),
              map((patientsWithSameName:[]) => {
                let workFlowCount = parseInt(currentPatientWarningList[0].workFlowCount)
                let requestList = []
                for( let patient of  patientsWithSameName){
                  requestList.push(this.getWorkFlowCountReq(patient, doTestType, appName))
                  filteredPatientsWithSameName.push(patient)
                }
                if (requestList.length > 0) {
                  combineLatest(requestList).subscribe((workFlowCountResponses)=> {
                    let index = 0
                    workFlowCountResponses.forEach((response) => {
                        let patient = filteredPatientsWithSameName[index]
                        let name = patient.name[0].text
                        let mrn = patient.identifier[0].value
                        let workFlowCount = response[0].count.toString()
                        warning = {"id": patient.id, "name": name, "mrn": mrn, "dob": patient.birthDate, "workFlowCount": workFlowCount}
                        let identifiertoolTip = this.patientService.getIdentifierToolTip(patient.mergedIdentifiers)
                        warning["toolTip"] = identifiertoolTip.htmlContentIcon
                        sameNamePatientWarningList.push(warning)
                        warning["showToolTip"] = identifiertoolTip.showTooltip
                        index ++
                        });
                      let patientWarningList = [...currentPatientWarningList, ...sameNamePatientWarningList]
                      let tooltipText = this.getWarningTitle(workFlowCount, sameNamePatientWarningList)
                      this.openModal(tooltipText, patientWarningList, patientId);
                      this.session.setDuplicatePatientWarning(patientId);
                  })
                }
                else if (workFlowCount > 1
                          && !(this.currentApp === "ISPM-ONCOLOGY-PATHWAYS-NAVIGATOR-APP" || this.currentApp === 'ISPM-PATHOLOGY-GENOMICS-APP')){
                    let tooltipText = this.getWarningTitle(workFlowCount, sameNamePatientWarningList)
                    this.openModal(tooltipText, currentPatientWarningList, patientId);
                    this.session.setDuplicatePatientWarning(patientId);
                  } else {
                      if (this.proceedCallback) {
                          this.proceedCallback()
                      }
                  }
                  return
              })).subscribe()
          })).subscribe()
      })).subscribe()
  }
  private getWorkFlowCountReq(patientObj, doTestType, appName){
    let patientLinks = this.patientService.getPatientIDStrWithPrimary(patientObj)
    let url = `entity-tree/WorkListRow?WLRDOPatient=${patientLinks}&WLRDOtesttype=${doTestType}&WLRDOLatestRevisionStatus=!%3DStopped,Completed&_countOnly=true`
    if (!doTestType) {
      url = `entity-tree/UIPractWorkListRow?patientId=${patientLinks}&AppConfiguration=${appName}&revStatus=!%3DNavigation%20Complete,Test%20completed,Stopped,Failed,Canceled,Completed&_countOnly=true`
    }
    return this._ispmHttpClient.get(url,{cacheId:this._browserCacheService.getCacheId()});
  }

  private getPatientsWithSameName(name, patientObjs){
    let patientLinkArray = this.patientService.getPatientLinksWithPrimaryPatient(patientObjs)
    let patientsWithSameNameExcludingCurrentPatient = []
    let url = `entity-tree/patient?name:exact=${name}`
    return this._ispmHttpClient.get(url).pipe(
      map((patientsWithSameName) => {
          for( let patient of patientsWithSameName){
            if(patientLinkArray.includes(patient.id) == false) {
              patientsWithSameNameExcludingCurrentPatient.push(patient)
          }
        }
        let refinedDuplicatePatientList = this.patientService.groupPatientsByLink(patientsWithSameNameExcludingCurrentPatient)
        return refinedDuplicatePatientList;
      })
    );
  }

  private getWarningTitle(workFlowCount, sameNamePatientWarningList){
    let title = "Multiple worklist items found for selected patient"
    if (workFlowCount > 1 && sameNamePatientWarningList.length > 0){
        title = "Multiple worklist items found for selected patient and multiple patients found with identical name"
          }
    else if(sameNamePatientWarningList.length > 0){
      title = "Multiple patients found with identical name"
    }
    return title
  }
  private getCurrentPatientRow(patientObjs, doTestType, appName ){
    let currentPatientWarningList = []
    return this.getWorkFlowCountReq(patientObjs, doTestType, appName).pipe(take(1),distinctUntilChanged(),takeUntil(this._destroyed$.asObservable())
      ,map((workFlowCountResponse) => {
        let workFlowCount = get(workFlowCountResponse,"0.count", 0);
        let id = patientObjs.id
        let name = patientObjs.name[0].text
        let mrn = patientObjs.identifier[0].value
        let dob = patientObjs.birthDate
        let warning = { "id": id, "name": name , "mrn": mrn, "dob": dob, "workFlowCount": workFlowCount.toString() }
        let identifiertoolTip = this.patientService.getIdentifierToolTip(patientObjs.aggIdentifier)
        warning["toolTip"] = identifiertoolTip.htmlContentIcon
        warning["showToolTip"] = identifiertoolTip.showTooltip
        currentPatientWarningList.push(warning)
        return currentPatientWarningList;
      })
    );
  }
  private extractSelectedPatientDetails(patientId){
    // TODO no need to fetch the patient use it from redux store
    return this.user.getPatient(patientId).pipe(ArrayUtils.filterEmpty(),distinctUntilKeyChanged("id"),takeUntil(this._destroyed$.asObservable()),
     switchMap(response => {
        let currentPatient = response
        let patientLinks = this.patientService.getPatientLinksStr(currentPatient)
        if(patientLinks.length > 0) {
          let url = `entity-tree/patient?_id=${patientLinks}`
          return this._ispmHttpClient.get(url).pipe(
            map(linkedPatientList => {
              let identifierList = [currentPatient["aggIdentifier"]]
              for(let linkedPatient of linkedPatientList) {
                identifierList.push(linkedPatient.aggIdentifier)
              }
              currentPatient["aggIdentifier"] = this.patientService.mergeAggIdentifiers(identifierList)
              return currentPatient
            }))
          } else {
            return of(currentPatient)
        }
      })
    )
  }
  ngOnDestroy(): void {
    if (this.subscriber) { this.subscriber.unsubscribe(); }
    this.destroyed = true;
    this._destroyed$.next(true);
    this._destroyed$.complete();

  }

  private sortUsersArray(users): void {
    const index = users.findIndex((user) => this.userId === user.id);
    const item = users[index];
    users.splice(index, 1);
    users.unshift(item);
  }

  public openModal(tooltipText, patientWarningList, patientId) {
    // const redirectTo = 'dashboard.pathologist.' + this.redirectTo;
    this.subscriber = this._modalLoader.popupModal(PlaceholderModalComponent, {
      title: tooltipText,
      componentToLoad: UserCounterTableComponent,
      buttons: {
        approveBtn: 'Proceed with selection',
        declineBtn: 'Back'
      },
      payload: {
        patientWarningList: patientWarningList,
        selected: patientId
      },
      approveCallback: (selectedUserId) => {
        // if (selectedUserId === this.userId) return;
        // this._stateService.go(redirectTo, {patientId: selectedUserId, testId: "", revisionId: ""})
      },
    }, ModalTypes.WARNING)
      .map(response => response.payload || { })
      .finally(() => {
        if (this.showMergePatientModal) {
          this.openMergePatientModal();
        }
      })
      .subscribe((response: { status: modalResponse }) => {
        switch (response.status) {
          case modalResponse.approve:
            this.showMergePatientModal = true; // indicate to show Merge-Patient modal window
            if (this.proceedCallback){//If callback is defined, do not navigate
              this.proceedCallback();
            }
            break;
          case modalResponse.decline:
            if (this.backCallback){
              this.backCallback();
            }
            else{
              this._location.back();
            }
            break;
        }
      });
  }

  /**
   * open a dialog to warn if selected user has been merghed before
   */
  public openMergePatientModal() {

    if (this.destroyed) {
      return;
    }

    let modalTitle = null;

    // first, display the message if the patient was merged to another patient
    if (this.userMergedToMrn) {

      if (this.userInactive === true) {
        modalTitle = this.addPatientState('is inactive', null);
      }

      modalTitle = this.addPatientState('has been merged to patient\'s MRN: ' + this.userMergedToMrn, modalTitle);

    } else if (this.userMergedFrom === true) {
      modalTitle = this.addPatientState('has been merged', null);
    }

    // if no dialog's message to display - exit
    if (modalTitle == null) {
      return;
    }

    this.subscriber = this._modalLoader.popupModal(PlaceholderModalComponent, {
      title: modalTitle,
      componentToLoad: UserMergeNotificationModalComponent,
      buttons: {
        approveBtn: 'OK'
      },
      payload: { },
    }, ModalTypes.ALERT)
      .finally(() => {
        this.showMergePatientModal = false;
      })
      .subscribe(() => {
      });
  }

  private addPatientState(stateMsg: string, allMsg: string) {
    if (allMsg == null || allMsg.length === 0) {
      return 'This patient &nbsp<b>' + this.userName + '</b>&nbsp ' + stateMsg;
    } else {
      return allMsg + ' and ' + stateMsg;
    }
  }
}
